import React from 'react';
import { Col, Row } from 'reactstrap';

const PopupDescriptionComponent = (props) => {
    return (
        <div className="popup-description-component">
            {props.boldDescription &&
                <Row>
                    <Col>
                        <span className="bold description-bold d-block mr-auto ml-auto" dangerouslySetInnerHTML={{ __html: props.boldDescription }} />
                    </Col>
                </Row>
            }
            {props.description &&
                <Row>
                    <Col>
                        <span className="description d-block  mr-auto ml-auto" dangerouslySetInnerHTML={{ __html: props.description }} />
                    </Col>
                </Row>
            }
        </div>
 )
}

export default PopupDescriptionComponent;